module.exports = __webpack_public_path__ + "img/cate4.2a8bc4b0.png";